




















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IBlock } from "../../interfaces";

@Component({
  computed: {
    ...mapGetters("currency", { currencySymbol: "symbol" }),
    ...mapGetters("network", ["height"]),
  },
})
export default class BlockDetails extends Vue {
  @Prop({ required: true }) public block: IBlock;

  private price: number | null = 0;
  private currencySymbol: string;
  private height: number;

  get confirmations(): number {
    return this.height - this.block.blockNum;
  }
}
